
import type { PropType } from 'vue'
import type { BulkActionMessages } from '../../../models/i18n/tools.messages'
import { defineComponent } from 'vue'
import { UiTooltip } from '../../keen-ui'
import { EpbBadge } from '../epb-badge'
import { EpbButton } from '../epb-button'
import { useBulkActionToolbar } from './use-bulk-action-toolbar'

export default defineComponent({
  name: 'EpbBulkActionToolbar',
  components: {
    EpbButton,
    EpbBadge,
    UiTooltip,
  },
  props: {
    messages: {
      type: Object as PropType<BulkActionMessages>,
      default: () => ({}),
    },
  },
  emits: {
    clearAll: () => {},
    close: () => {},
  },
  setup(prop, { emit }) {
    const { selectedItems, isToolBarOpen, toggleToolbar, clearAllSelectedItems } =
      useBulkActionToolbar()

    function onClearAll() {
      clearAllSelectedItems()

      emit('clearAll')
    }

    function onClose() {
      toggleToolbar()

      emit('close')
    }

    return {
      baseClass: 'epb-bulk-action-toolbar',
      selectedItems,
      isToolBarOpen,
      onClearAll,
      onClose,
    }
  },
})
